import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { safeDecimal } from '@/helpers/number';
import { EMPTY_DASH } from '@/helpers/constants';
import { prettyFloatMoney } from '@/helpers/utils';
import s from './index.module.scss';

export const CashTooltip = ({ finance }) => {
  const { t } = useTranslation('components');

  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className={s.row} style={{ color: 'var(--Black-400, #151515)' }}>
          <div className="f-body-regular">{t('top_header.cash_account')}</div>
          <div className="f-body-medium">
            {finance
              ? prettyFloatMoney(
                  safeDecimal(finance.cash).add(safeDecimal(finance?.frozen_amount)).toNumber(),
                )
              : EMPTY_DASH}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-label">{t('top_header.available_cash')}</div>
          <div className="f-label">{finance ? prettyFloatMoney(finance.cash) : EMPTY_DASH}</div>
        </div>
        {!!safeDecimal(finance?.frozen_amount).toDecimalPlaces(2).toNumber() && (
          <div className={s.row}>
            <div className="f-label">{t('top_header.reserved_for_refin')}</div>
            <div className="f-label">{prettyFloatMoney(finance.frozen_amount)}</div>
          </div>
        )}
      </div>
      <div className={classnames(s.note, 'f-label')}>{t('top_header.cash_note')}</div>
    </div>
  );
};
